//import api from '../api'
import { newAPIPost } from '../api/index.js';

export default {
  state: {
    callLogs: [],
    searchRequest: {},
  },
  mutations: {
    updateCallLogs(state, callLogs) {
      state.callLogs = callLogs;
    },
    updateSearchCallLogRequest(state, searchRequest) {
      state.searchRequest = searchRequest;
    },
  },
  actions: {
    async loadCallLogs({ commit, state }, request) {
      const fallbackRequest = request || state.searchRequest;
      const requestToSend = JSON.parse(JSON.stringify(fallbackRequest));
      if (requestToSend.storeFrom && !requestToSend.storeTo) {
        requestToSend.storeTo = requestToSend.storeFrom;
      }
      if (requestToSend.stateFrom && !requestToSend.stateTo) {
        requestToSend.stateTo = requestToSend.storeFrom;
      }
      if (requestToSend.cityFrom && !requestToSend.cityTo) {
        requestToSend.cityTo = requestToSend.cityFrom;
      }

      if(requestToSend.callDateTo){
        requestToSend.callDateTo = moment(requestToSend.callDateTo).endOf('d').toDate();
      }
      if (requestToSend.pickupEtaTo) {
        requestToSend.pickupEtaTo = moment(requestToSend.pickupEtaTo).endOf('d').toDate();
      }

      if (requestToSend.callDateFrom && !requestToSend.callDateTo) {
        requestToSend.callDateTo = moment(requestToSend.callDateFrom).endOf('d').toDate();
      }
      if (requestToSend.pickupEtaTo && !requestToSend.pickupEtaFrom) {
        requestToSend.pickupEtaFrom = moment(requestToSend.pickupEtaTo).endOf('d').toDate();
      }

      //const result = await api.post('/api/w/callLogs', requestToSend);
      const result = await newAPIPost('/api/w/callLogs', requestToSend);
      commit('updateSearchCallLogRequest', fallbackRequest);
      return commit('updateCallLogs', result);
    },
    saveCallLogs({ dispatch }, request) {
      //return api.post('/api/w/callLogs/action', request)
      return newAPIPost('/api/w/callLogs/action', request)
    },
  },
  getters: {
    getCallLogs: state => state.callLogs,
  },
};
